import { render, staticRenderFns } from "./StartScreen.vue?vue&type=template&id=b714b736&scoped=true"
import script from "./StartScreen.vue?vue&type=script&lang=js"
export * from "./StartScreen.vue?vue&type=script&lang=js"
import style0 from "./StartScreen.vue?vue&type=style&index=0&id=b714b736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b714b736",
  null
  
)

export default component.exports